<template>
  <div>
    <div class="text-xs md:text-base font-medium leading-none text-gray-500 break-all">
      <div data-test="dashboard-title-activityfeed">
        <slot />
      </div>
    </div>
  </div>
</template>
